module.exports = __webpack_public_path__ + "static/media/nature-flower.7dc4e52c.png";